import { HttpClient } from '../http-client';
class SpaceHttpClient extends HttpClient {
    async getSpaces(projectId) {
        return this.get(`/projects/${projectId}/spaces`);
    }
    async getSpaceDetail(spaceId) {
        return this.get(`/spaces/${spaceId}`);
    }
    async createSpace(data) {
        return this.post('/spaces', data);
    }
    async updateSpace(spaceId, data) {
        return this.put(`/spaces/${spaceId}`, data);
    }
    async deleteSpace(spaceId) {
        return this.delete(`/spaces/${spaceId}`);
    }
    async bulkReorderSpaceTabs(data) {
        return this.put('spaces/bulk-reorder-space-tabs', data);
    }
    async bulkReorderSpaces(data) {
        return this.put('projects/bulk-reorder-spaces', data);
    }
}
export const SpaceAPI = new SpaceHttpClient();
